// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CodeGraphNodeSchema } from './CodeGraphNodeSchema'
import type { CodeGraphNode } from './CodeGraphNodeSchema'
import { CodeGraphEdgeSchema } from './CodeGraphEdgeSchema'
import type { CodeGraphEdge } from './CodeGraphEdgeSchema'
import { TechnologySchema } from './TechnologySchema'
import type { Technology } from './TechnologySchema'
import { CodeGraphSchema } from './CodeGraphSchema';

/////////////////////////////////////////
// CODE GRAPH RELATION SCHEMA
/////////////////////////////////////////

export type CodeGraphRelations = {
  nodes: CodeGraphNode[];
  edges: CodeGraphEdge[];
  technologies: Technology[];
};

export type CodeGraphWithRelations = z.infer<typeof CodeGraphSchema> & CodeGraphRelations

export const CodeGraphWithRelationsSchema: z.ZodType<CodeGraphWithRelations> = CodeGraphSchema.merge(z.object({
  nodes: z.lazy(() => CodeGraphNodeSchema).array(),
  edges: z.lazy(() => CodeGraphEdgeSchema).array(),
  technologies: z.lazy(() => TechnologySchema).array(),
}))